import Calendar from "components/commons/Calendar";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { HealthEventCard } from "./HealthEventCard";

export const HealthEventCalendar = ({
    healthEvents = [],
    showUser = true,
    onDataChange = () => { },
    onEventClick = () => { },
}) => {

    const [t] = useTranslation(["health"])
    const [criticOnly, setCriticOnly] = useState(false)

    function getIcon(type) {
        switch (type) {
            case "FALL_DETECT": return <i className="fa-solid fa-person-falling"></i>
            case "NO_ACTIVITY": return <i className="fa-solid fa-ban"></i>
            case "HIGH_HR":
            case "LOW_HR": return <i className="fa-solid fa-heart-circle-exclamation"></i>
            case "BIA": return <i className="fa-solid fa-chart-pie"></i>
            case "ECG": return <i className="fa-solid fa-heart-pulse"></i>
            case "SPO2": return <i className="fa-solid fa-droplet"></i>
            default: return <i className="fa-solid fa-question"></i>
        }
    }

    function getColor(type) {
        switch (type) {
            case "FALL_DETECT":
            case "NO_ACTIVITY": return "darkred"
            case "HIGH_HR":
            case "LOW_HR": return "#4d0802"
            case "SPO2": return "#2962d2ff"
            case "BIA": return "#72982cff"
            case "ECG": return "#1a803bff"
            default: return "#2c363c"
        }
    }

    function getUnit(type) {
        switch (type) {
            case "FALL_DETECT": return "m/s^2"
            case "HIGH_HR":
            case "LOW_HR": return "bpm"
            case "BIA": return "%"
            case "SPO2": return "%"
            default: return null
        }
    }

    function isCritic(type) {
        switch (type) {
            case "ECG":
            case "SPO2":
            case "BIA": return false
            default: return true
        }
    }

    const formatTimestamp = (seconds) => {
        if (!seconds) return "";
        const date = new Date(seconds * 1000);
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        return `${hours}:${minutes}`;
    };

    // Mappatura delle assenze
    let events = []
    events = healthEvents.map(healthEvent => {

        if (criticOnly && !isCritic(healthEvent.type))
            return {}

        const startDate = new Date(healthEvent.timestamp * 1000);
        const endDate = new Date(healthEvent.timestamp * 1000 + 5 * 60 * 1000); // durata fittizia di 5 minuti
        return {
            id: healthEvent.user.guid + healthEvent.timestamp,
            title: t(`health:entity.events.${healthEvent.type}`),
            start: startDate,
            end: endDate,
            allDay: false,
            color: getColor(healthEvent.type),
            className: "custom-health-event", // classe per stilizzazione
            display: "block",
            extendedProps: {
                eventDto: healthEvent
            }
            // extendedProps: {
            //     userDisplayname: healthEvent.user.displayName.split(" ")[0][0] + ". " + healthEvent.user.displayName.split(" ")[1],
            //     userGuid: healthEvent.user.guid,
            //     img: <UserImage guid={healthEvent.user.guid} size={32} border={true} />,
            //     type: healthEvent.type,
            //     value: healthEvent.value,
            //     unit: getUnit(healthEvent.type),
            //     time: healthEvent.timestamp,
            // }
        };
    });

    function renderEventContent(eventInfo) { 
        return <HealthEventCard event={eventInfo.event.extendedProps.eventDto} showUser={showUser} template="COMPACT" />
    }

    //     function renderEventContent(eventInfo) {
    //     return (
    //         <div key={eventInfo.event.id} className="p-1">
    //             <div className="row text-end">
    //                 <div className="col text-start">
    //                     {getIcon(eventInfo.event.extendedProps.type)}
    //                 </div>
    //                 <div className="col text-end">
    //                     <small> {formatTimestamp(eventInfo.event.extendedProps.time)}</small>
    //                 </div>
    //             </div>
    //             <div className="d-flex align-items-center justify-content-between mt-2">

    //                 <b>{eventInfo.event.title}</b>
    //                 <small className="opacity-75">{eventInfo.event.extendedProps.value} <small className="opacity-50">{eventInfo.event.extendedProps.unit}</small></small>
    //             </div>
    //             <div className="d-flex align-items-center gap-1 mt-3 bg-opacity-50 bg-black bg-opacity-25 rounded-pill ">

    //                 {showUser && eventInfo.event.extendedProps.img}

    //                 {
    //                     showUser &&
    //                     eventInfo.event.extendedProps.userDisplayname
    //                 }

    //             </div>


    //         </div>
    //     )
    // }


    return (
        <>
            <div className="row p-2">
                <div className="col-auto">
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="" onChange={() => setCriticOnly(!criticOnly)} checked={criticOnly} id="flexCheckDefault" />
                        <label className="form-check-label" htmlFor="flexCheckDefault">
                            {t("health:actions.see_critical_events_only")}
                        </label>
                    </div>

                </div>
            </div>
            <Calendar
                events={events}
                onMonthChange={onDataChange}
                onEventClick={onEventClick}
                renderEventContent={renderEventContent}
            />

        </>)


}